export default __webpack_public_path__ + "static/media/item-3.264a5c56.jpg";